// This function creates a formula object with a name, description and calculator function
// Parameters:
//   - name: The name of the formula
//   - description: A description of what the formula calculates
//   - calculator: The function that performs the actual calculation
// Returns an object with name, description and calculate properties

export const createFormula = (name, description, calculator) => {
   return {
     name,
     description,
     calculate: calculator,
   };
};
